import { Answer } from './qa.model';

export class Color {
  ColorName: string;
  RedValue: number;
  GreenValue: number;
  BlueValue: number;
  Opacity: string;
  OpacityName: string;
  ItemGUID: string;
  Elite: string;
  IsSelected: boolean = false;
  R: number;
  G: number;
  B: number;
  IsElite: boolean;
  IsWaterGuard: boolean;
  SwatchImage: string;
  Name: string;
  Row: number;
  Column: number;
  BaseProduct: number;
  TransparencyImage: string;
  BackgroundImage: string;
}
export class ProjectImage {
    ProjectImage: string;
    MaskImage: string;
    BoardImage: string;
    Opacity: string;
    WoodType: string;
    WoodGrain:string;
    IsDefault: boolean;
}
export class ColorGroup {
  OpacityName: string;
  OpacityYear: string;
  OpacityCulture: string;
  OpacitySwatchTransparency: number;
  ItemOrder: number;
  ItemGUID: string;
  StainImage: string;
  StainDescription: string;
  OpacityColors: Array<Array<Color>>;
  PopupFilter: string;
  UnorderedColors: Color[];
}
export class BoardImage {
  Opacity: string;
  WoodType: string;
  BoardImage: string;
  BoardSwatchImage: string;
}
export class TranslatableOpacities {
  DocumentName: string;
  SubHeading: string;
  PopUpNodeId: string;
  OpacityDescption: string;
  OpacityGUID: string;

}
export class VisualizerResponse {
    ColorGroups: ColorGroup[];
    ProjectImages: ProjectImage[];
    PostVisualizerAnswers:Answer[];
    BoardImages: BoardImage[];
    Opacities: TranslatableOpacities[];
}

export interface VisualizerRequest {
    SiteName: string;
    OpacityIds: string[];
    ProjectId: string;
}
export interface PostVisualizerRequest {
  SiteName: string;
  EliteGuid: string;
  OpacityGuid: string;
}
export class VisualizerStateReady {
  DataIsReady: boolean;
  AnimationIsDone: boolean;
  ImageIsLoaded: boolean;
  constructor() {
    this.DataIsReady = false;
    this.AnimationIsDone = false;
    this.ImageIsLoaded = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/color.model.ts